export const ASSOCIACAO_VINCULO_STATUS_OPTIONS = [
  { value: 'todos', label: 'Todas (com e sem vínculo)' },
  { value: 'com', label: 'Com vínculo' },
  { value: 'sem', label: 'Sem vínculo' }
];

export const associacaoVeiculoFilterConfig = [
  {
    id: 'NumeroFrota',
    type: 'text',
    label: 'Número Frota',
    placeholder: 'Filtrar por frota'
  },
  {
    id: 'Placa',
    type: 'text',
    label: 'Placa',
    placeholder: 'Filtrar por placa'
  },
  {
    id: 'Segmento',
    type: 'searchSelect',
    label: 'Segmento',
    placeholder: 'Selecione um ou mais segmentos',
    isMulti: true,
    showSelectAll: true,
    options: []
  },
  {
    id: 'Modelo',
    type: 'searchSelect',
    label: 'Modelo',
    placeholder: 'Selecione um ou mais modelos',
    isMulti: true,
    showSelectAll: true,
    options: []
  },
  {
    id: 'StatusVinculo',
    type: 'select',
    label: 'Status Vínculo',
    placeholder: 'Selecione...',
    options: ASSOCIACAO_VINCULO_STATUS_OPTIONS
  }
];
